module.exports = __webpack_public_path__ + "img/901142573.4aeb37b0.png";